import React from "react";
import { set } from "dot-prop-immutable";
import { connect } from 'react-redux';
import { SimpleForm as Form, Button, Switch, Collapse, Radio } from '@whalecloud/fdx';
import { toolFormAttr, toolCollapseAttr } from '@utils/util';
import CommonItemSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonItemSettings';
import { getElementWithChildren } from '@whalecloud/page-builder-core/selectors';
import isEqual from "lodash/isEqual";
import { getLocale } from '@utils/util';

const valueKey = 'data.formItemSettings';
const { Panel } = Collapse;

/**
 * @param  {Object} element 当前元素
 * @param  {Function} updateElement 修改属性后，调用此方法更新element
 */
const CollapseSettings = (props) => {
  const { dropElement, updateElement, element } = props;
  const messages = getLocale();

  const { data: { formItemSettings = {} } = {}, formSettings = {} } = element;
  const { name, label } = formSettings;
  const {
    bordered = true,
    showArrow = true,
    expandIconPosition = 'left',
  } = formItemSettings;

  const initialValues = {
    name,
    label,
    bordered,
    showArrow,
    expandIconPosition,
  };

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      const propName = `${valueKey}.${key}`;
      const value = obj[key];
      const newElement = set(element, propName, value);
      updateElement({
        element: newElement,
      });
    });
  };

  const handleNewPanel = () => {
    // 增加子节点panel
    dropElement({
      source: { type: 'card', target: ['collapse'] },
      parentEl: element,
      target: { id: element.id, type: element.type, position: element.elements.length },
    });
  };

  return (
    <React.Fragment>
      <Collapse {...toolCollapseAttr} defaultActiveKey={['1', '2']}>
        <Panel header={messages["PAGEBUIDER_SETTINGS"]} key="1">
          <CommonItemSettings allowClearHide placeholderHide defaultValueHide disabledHide requiredHide />
          <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
            <Form.Item label={messages['PAGEBUIDER_SETTINGS_BORDERED']} name="bordered" valuePropName="checked">
              <Switch />
            </Form.Item>
            <Form.Item label={messages['PAGEBUIDER_SETTINGS_COLLAPSE_ARROW']} name="showArrow" valuePropName="checked">
              <Switch />
            </Form.Item>
            <Form.Item label={messages['PAGEBUIDER_SETTINGS_EXPANDICONPOSITION']} name="expandIconPosition">
              <Radio.Group buttonStyle="solid" size="small">
                <Radio.Button value="left">{messages['PAGEBUIDER_SETTINGS_LEFT']}</Radio.Button>
                <Radio.Button value="right">{messages['PAGEBUIDER_SETTINGS_RIGHT']}</Radio.Button>
              </Radio.Group>
            </Form.Item>
          </Form>
          <Button onClick={() => handleNewPanel()} style={{ width: '100%', marginBottom: 10 }}>{messages['PAGEBUIDER_SETTINGS_NEW_PANEL']}</Button>
        </Panel>
      </Collapse>
    </React.Fragment>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  dropElement: payload => {
    dispatch({
      type: 'appBuilder/dropElement',
      payload,
    });
  },
});

export default connect<any, any, any>(
  (state, props) => ({
    state,
    element: getElementWithChildren(state, props.element.id),
  }),
  mapDispatchToProps,
  null,
  { areStatePropsEqual: isEqual }
)(CollapseSettings);
